// extracted by mini-css-extract-plugin
module.exports =  {"text":"ReEnterPasswordForm-_Y0R__text","message":"ReEnterPasswordForm-qiVU__message"};